import { Component } from 'react';
import PropTypes from 'prop-types';

class CrossComponent extends Component {
  render() {
    return (
      <div onClick={this.props.onClickHandler} className="cross-component">
        <svg
          version="1.1" id="Layer_1" x="0px" y="0px"
          viewBox="0 0 154.5 154.5"
        >
          <g>
            <g>
              <path
                className="st0" d="M130.9,127L81.1,77.2l49.8-49.8l-3.9-3.9L77.2,73.4L27.5,23.6l-3.9,3.9l49.8,49.8L23.6,127l3.9,3.9l49.8-49.8
              l49.8,49.8L130.9,127z M130.9,127"
              />
            </g>
            <g>
              <path className="st0" d="M154.5,154.5H0V0h154.5V154.5z M4.5,150H150V4.5H4.5V150z" />
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

CrossComponent.propTypes = {
  onClickHandler: PropTypes.func,
};

CrossComponent.defaultProps = {
  onClickHandler: () => {},
};

export default CrossComponent;
